module.exports = __webpack_public_path__ + "static/media/SadFace.91bc8ea2.png";